import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from 'Src/api'
import { providesList } from 'Utils/rtk-query'
import flowsApi from '../../Bots/bot-flows.service'

export const kbApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'kbApi',
  tagTypes: ['KBs', 'Section', 'FlowKBSections'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    listKbs: builder.query({
      query: () => '/v1/kb/',
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(flowsApi.util.invalidateTags(['FlowKBSections']))
      },
      providesTags: (result) => [...providesList(result, 'KBs')]
    }),
    linkKb: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/kb',
          method: 'POST',
          body: payload
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(flowsApi.util.invalidateTags(['FlowKBSections']))
      },
      invalidatesTags: [{ type: 'KBs', id: 'LIST' }]
    }),
    updateKb: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data
        return {
          url: `/v1/kb/${id}`,
          method: 'PATCH',
          body: payload
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(flowsApi.util.invalidateTags(['FlowKBSections']))
      },
      invalidatesTags: (_result, _error, data) => [{ type: 'KBs', id: data.id }]
    }),
    syncKb: builder.mutation({
      query: (id) => {
        return {
          url: `/v1/kb/${id}/sync`,
          method: 'PUT'
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(flowsApi.util.invalidateTags(['FlowKBSections']))
      },
      invalidatesTags: (_result, _error, id) => [{ type: 'KBs', id }]
    }),
    deleteKB: builder.mutation({
      query: (id) => {
        return {
          url: `/v1/kb/${id}`,
          method: 'DELETE'
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(flowsApi.util.invalidateTags(['FlowKBSections']))
      },
      invalidatesTags: (_result, _error, id) => [{ type: 'KBs', id }]
    }),
    getKbSections: builder.query({
      query: (id) => `/v1/kb/${id}/sections`,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(flowsApi.util.invalidateTags(['FlowKBSections']))
      },
      providesTags: ['Section']
    })
  })
})

export const {
  useListKbsQuery,
  useLinkKbMutation,
  useUpdateKbMutation,
  useSyncKbMutation,
  useDeleteKBMutation,
  useGetKbSectionsQuery
} = kbApi

export default kbApi
